import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { clearAttachmentFiles } from 'owa-calendar-compose-form-actions';
import { mutator } from 'satcheljs';

export default mutator(clearAttachmentFiles, actionMessage => {
    const store = getComposeStore();
    store.attachmentFiles = null;
});

export { AttachmentFileList } from 'owa-attachment-well-data';
